var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityLogLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.632,
    height: 12.25,
    viewBox: "0 0 16.632 12.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-activity",
    transform: "translate(-1.9 -9.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8635",
    "data-name": "Group 8635",
    transform: "translate(2 10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9653",
    "data-name": "Path 9653",
    d: "M18.158,10H2.274A.274.274,0,0,0,2,10.274v11.5a.274.274,0,0,0,.274.274H18.158a.274.274,0,0,0,.274-.274v-11.5A.274.274,0,0,0,18.158,10Zm-.274,11.5H2.548V10.548H17.884Z",
    transform: "translate(-2 -10)",
    fill: "#a4e3d9",
    stroke: "#a4e3d9",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9654",
    "data-name": "Path 9654",
    d: "M40.274,19.286a.273.273,0,0,0,.194-.08l2.271-2.271v.982a.274.274,0,1,0,.548,0V16.274A.275.275,0,0,0,43.012,16H41.369a.274.274,0,1,0,0,.548h.982L40.08,18.819a.274.274,0,0,0,.194.467Z",
    transform: "translate(-29.593 -14.357)",
    fill: "#a4e3d9",
    stroke: "#a4e3d9",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9655",
    "data-name": "Path 9655",
    d: "M43.012,37.1a.274.274,0,0,0-.274.274v.982L40.467,36.08a.274.274,0,0,0-.387.387l2.271,2.271h-.982a.274.274,0,1,0,0,.548h1.643a.275.275,0,0,0,.274-.274V37.369A.274.274,0,0,0,43.012,37.1Z",
    transform: "translate(-29.593 -28.88)",
    fill: "#a4e3d9",
    stroke: "#a4e3d9",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9656",
    "data-name": "Path 9656",
    d: "M9.274,22.834h1.369a.274.274,0,0,0,.253-.168L12,20.007l1.671,4.3a.274.274,0,0,0,.226.173l.03,0a.274.274,0,0,0,.228-.122l1.014-1.521h6.152a.274.274,0,0,0,0-.548h-6.3a.274.274,0,0,0-.228.122l-.8,1.2-1.726-4.438A.274.274,0,0,0,12.016,19a.265.265,0,0,0-.256.168l-1.3,3.118H9.274a.274.274,0,1,0,0,.548Z",
    transform: "translate(-7.083 -16.535)",
    fill: "#a4e3d9",
    stroke: "#a4e3d9",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9657",
    "data-name": "Path 9657",
    d: "M18.274,42.548h2.739a.274.274,0,0,0,0-.548H18.274a.274.274,0,1,0,0,.548Z",
    transform: "translate(-13.618 -33.236)",
    fill: "#a4e3d9",
    stroke: "#a4e3d9",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9658",
    "data-name": "Path 9658",
    d: "M32.468,42.08a.275.275,0,0,0-.3-.058.249.249,0,0,0-.148.148.259.259,0,0,0,0,.208.283.283,0,0,0,.058.09.318.318,0,0,0,.09.057.274.274,0,0,0,.1.022.288.288,0,0,0,.194-.079.286.286,0,0,0,.057-.09.258.258,0,0,0,0-.208A.283.283,0,0,0,32.468,42.08Z",
    transform: "translate(-23.784 -33.237)",
    fill: "#a4e3d9",
    stroke: "#a4e3d9",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9659",
    "data-name": "Path 9659",
    d: "M22.108,46H18.274a.274.274,0,1,0,0,.548h3.834a.274.274,0,0,0,0-.548Z",
    transform: "translate(-13.618 -36.141)",
    fill: "#a4e3d9",
    stroke: "#a4e3d9",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9660",
    "data-name": "Path 9660",
    d: "M8.274,43.191H9.917a.274.274,0,0,0,.274-.274V41.274A.274.274,0,0,0,9.917,41H8.274A.274.274,0,0,0,8,41.274v1.643A.274.274,0,0,0,8.274,43.191Zm.274-1.643h1.1v1.1h-1.1Z",
    transform: "translate(-6.357 -32.51)",
    fill: "#a4e3d9",
    stroke: "#a4e3d9",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityLogLight);
export default __webpack_public_path__ + "static/media/activity-log-light.3681311be4e79905734787d5d8ef8b9d.svg";
export { ForwardRef as ReactComponent };